var map = {
	"./economists-white.png": "2f83",
	"./experts-white.png": "374b",
	"./guardians-white.png": "1ae3",
	"./practitioners-white.png": "2919",
	"./racers-white.png": "4bce",
	"./stylists-white.png": "e87b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87dc";